export default "__VITE_ASSET__3K3t$7ih__"